import { useContext, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import OtpDisplay from '../../../components/OtpDisplay';
import DriverInfoDisplay from '../../../components/DriverInfoDisplay';
import AutoNavigate from '../../../components/AutoNavigate';
import { AppStateContext } from '../../../context/AppStateContextProvider';
import { defaultApiClient } from '../../../apiClients/apiClient';

export default function RideBookingInitializedPage() {
    const { userCurrentRide, fetchUserInteractionState } = useContext(AppStateContext);

    const [isCancelling, setIsCancelling] = useState(false);

    const handleCancelRideButtonClick = async () => {
        setIsCancelling(true);

        if (!window.confirm('Are you sure you want to cancel this ride?')) {
            setIsCancelling(false);
            return;
        }

        const cancellationReason = 'UNKNOWN';

        const cancelRideBookingResponse =
            await defaultApiClient.methods.rides.customer.cancelRideBooking(cancellationReason);
        if (!cancelRideBookingResponse.success) {
            console.log(cancelRideBookingResponse);
            window.alert(
                `${cancelRideBookingResponse.error.userFriendlyError.title}: ${cancelRideBookingResponse.error.userFriendlyError.detail}`
            );
            setIsCancelling(false);
            return;
        }

        setIsCancelling(false);
        fetchUserInteractionState();
    };

    return (
        <Box
            sx={{
                width: '100vw',
                height: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <AutoNavigate />
            <Box
                sx={{
                    backgroundImage: `url('/green-background.png')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '100vw',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img src="/tick-gif.gif" style={{ width: '150px', height: '150px' }} />
                <Typography
                    variant="h3"
                    sx={{
                        mt: -2,
                        fontSize: 32,
                        fontWeight: '600',
                        color: 'white',
                        mb: 2,
                    }}
                >
                    Booking Confirmed
                </Typography>
                <OtpDisplay otpText={userCurrentRide?.oneTimePassword.value} />
                <Typography
                    variant="h3"
                    sx={{
                        color: '#000000',
                        backgroundColor: 'rgb(249,164,9)',
                        borderRadius: 3,
                        paddingLeft: 1.5,
                        paddingRight: 1.5,
                        paddingTop: 1.0,
                        paddingBottom: 1.0,
                        mt: 2,
                        fontSize: 24,
                        fontWeight: '900',
                    }}
                >
                    Driver is waiting outside.
                </Typography>
            </Box>

            <Box
                sx={{
                    width: '100vw',
                    height: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                    backgroundColor: 'rgb(242,242,242)',
                }}
            >
                <DriverInfoDisplay driver={userCurrentRide?.driver} displayCallButton={true} />

                <Button
                    variant="contained"
                    color="error"
                    sx={{
                        pt: 1,
                        borderRadius: 1000,
                        minWidth: 200,
                        '&.Mui-disabled': {
                            opacity: 1,
                            backgroundColor: (theme) => theme.palette.error.main,
                            color: (theme) => theme.palette.error.contrastText,
                        },
                    }}
                    onClick={handleCancelRideButtonClick}
                    disabled={isCancelling}
                >
                    <span
                        style={{
                            opacity: isCancelling ? 0 : 1,
                            transition: 'opacity 150ms',
                        }}
                    >
                        Cancel Ride
                    </span>

                    {isCancelling && (
                        <CircularProgress
                            size="1em"
                            thickness={5}
                            color="inherit"
                            sx={{
                                position: 'absolute',
                            }}
                        />
                    )}
                </Button>
            </Box>
        </Box>
    );
}
